import styled from '@emotion/styled';
import { Pagination, Theme } from '@mui/material';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { FormSelect } from 'components/molecules/FormSelect';

export const StyledPagination = styled(Pagination)`
  margin-top: 6px;

  & .MuiPaginationItem-page {
    color: ${colors.primary900};
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    border: 1px solid ${colors.primary50};
    border-radius: 4px;
  }

  & .Mui-selected {
    background-color: ${colors.primary500} !important;
    color: ${colors.white};
  }
`;

export const PaginationWrapper = styled(Grid)`
  margin: 15px 0 10px;

  ${({ theme }) => `
    ${(theme as Theme).breakpoints.down('md')} {
      justify-content: space-between;
      };
      `};
`;

export const PaginationPerPage = styled(Grid)`
  margin-top: 6px;
  width: 180px;
  max-width: 180px;

  ${({ theme }) => `
    ${(theme as Theme).breakpoints.down('md')} {
      & {
          width: auto;
          max-width: inherit;
          padding-left:0 !important;
          
        };
      };
      `};
`;
export const PaginationSummary = styled(Grid)`
  margin-top: 12px;
  width: 100px;
  max-width: 100px;

  ${({ theme }) => `
    ${(theme as Theme).breakpoints.down('md')} {
      & {width: auto; max-width: inherit;};
      };
      ${(theme as Theme).breakpoints.down('sm')} {
      & {order:1;};
      };
      `};
`;
export const PaginatorPerPageSelect = styled(FormSelect)`
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const StyledCurrentPageMobile = styled(FormSelect)`
  margin-top: 1px;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  & label {
    margin-top: 8px;
  }
`;
